var sucStore = {},
    sucProduct = {},
    sucHome = {},
    bubbles = {},
    site = {};
  
sucStore.init = function() {
  sucStore.getDate(); 
}

sucStore.getDate = function() {
  var dateContainer = document.getElementById('date'),
      today = new Date(),
      dayNames= ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      monthNames = ['January', 'February', 'March', 'April', 'May', 'June','July', 'August', 'September', 'October', 'November', 'December'],
      dayText = dayNames[today.getDay()],
      monthText = monthNames[today.getMonth()],
      dateText = today.getDate(),
      weekday = today.getDay();

  if ([0,1,2,3,4,5,6].indexOf(weekday) > -1) {
    var hours = '11-6PM';
  } else {
    var hours = 'closed';
  }

  // outputs something like TUESDAY, NOVEMBER 19, CLOSED
  dateContainer.innerHTML = '' + dayText + ', ' + monthText + ' ' + dateText + ', ' + hours + '';

}

sucProduct.init = function() {
  sucProduct.variants();
  sucProduct.imageSwap();
  sucProduct.moveFeaturedImage();
  
  window.addEventListener('resize:end', function(event) {
    sucProduct.moveFeaturedImage();
  }, false);
}

sucProduct.variants = function() {
  var variantSelects = jQuery('.single-option-selector');
  
  jQuery.each(variantSelects, function() {
    var childOption = jQuery(this).find('option');
    var parentLabel = jQuery(this).prev('label');
    
    if (childOption.length <= 1) {
      var optionText = childOption.html();
      parentLabel.after(optionText);
      jQuery(this).hide();
    }
    
  });
}

sucProduct.imageSwap = function() {
  var imageThumbs = jQuery('a.product-thumb'),
      mainImage = jQuery('.image-main');
  
  jQuery.each(imageThumbs, function() {
      jQuery(this).on('click', function(e) {
        e.preventDefault();
        var thisSrc = jQuery(this).attr('href');
        mainImage.addClass('js-active');
        mainImage.attr('src',thisSrc);
      });
    }
  );
  
  mainImage.on('click', function() {
    if(jQuery(this).hasClass('js-active')){
      jQuery(this).removeClass('js-active');
    }
  }); 
}

// move image on mobile
sucProduct.moveFeaturedImage = function() {
  var windowWidth = window.innerWidth,
      mainImage = jQuery('.image-main'),
      gallery = jQuery('.product-photo-container'),
      description = jQuery('.product-description');
  if(windowWidth < 600) {
    mainImage.appendTo(gallery);
  } else {
    mainImage.appendTo(description);
  }
}

sucHome.init = function() {
  if (!Modernizr.touch) {
    sucHome.productAjax();
   	bubbles.init();
  }
}

sucHome.productAjax = function() {
  var productImages = jQuery('.blog-post a');
  
  jQuery.each(productImages, function() {
  	var linkHref = jQuery(this).attr('href');
    var parentSpan = jQuery(this).closest('span');
    parentSpan.append(jQuery('<div class="bubble">'));
    var nextBubble = jQuery(this).siblings('.bubble');
    
    $.get(linkHref, function(data) {
      $.each(['designer', 'title', 'price', 'description'], function(i, key) {
        var dataKeys = jQuery(data).find('.ajax-' + key).html();
        nextBubble.append(jQuery('<div class="ajaxed-'+key+'">').html(dataKeys));
      });
    }, 'html');
   
    jQuery(this).one('click', function() {
      event.preventDefault();
      nextBubble.addClass('active');
    });
    
    nextBubble.on('click', function() {
      jQuery(this).css({
        transform: 'scale(2,2)',
        opacity: '0'
      });
      jQuery(this).removeClass('active');
      setTimeout(function(){
      	nextBubble.css('transform', 'scale(1,1)');
      }, 350);
    });
    
  });
  
}

site.init = function() {
  site.customClass();
}

site.customClass = function() {
	var urlString = window.location.href,
      urlParts = urlString.split('/'),
      urlValue;
	if (urlParts[urlParts.length-1].length === 0) {
	  urlValue = urlParts[urlParts.length-2];
	} else {
	  urlValue = urlParts[urlParts.length-1];  
	}
	jQuery('body').addClass(urlValue);
}

bubbles.init = function() {
  var productImages = $('a.product-thumb');
  var bubbles = $('.bubble');
  
  bubblePos();
  
  jQuery(window).resize(function(event) {
    bubblePos();
  });
  
  function bubblePos() {
    var windowWidth = jQuery(window).width();
        halfWidth = windowWidth / 2;
    bubbles.each(function() {
        var el = $(this);
        var xPos = jQuery(el).offset().left;
        if(xPos > halfWidth) {
          el.addClass('left');
        } else if(xPos < halfWidth) {
          el.removeClass('left');
        }
      }
    );
  };

  jQuery.each(productImages, function() {
    var nextBubble = jQuery(this).siblings('.bubble');
   
    jQuery(this).one('click', function() {
      event.preventDefault();
      nextBubble.addClass('active');
    });
    
    nextBubble.on('click', function() {
      jQuery(this).css({
        transform: 'scale(2,2)',
        opacity: '0'
      });
      jQuery(this).removeClass('active');
      setTimeout(function(){
      	nextBubble.css('transform', 'scale(1,1)');
      }, 350);
    });
    
  });  
}
